'use strict';

/* スムーススクロール */

const pageTopBtn = document.querySelector('.p-pagetop__button');
function smoothScroll() {
  pageTopBtn?.addEventListener('click', (e) => {
    e.preventDefault();

    const target = document.querySelector('#top')!;

    //現在のスクロール量を取得
    const elemY = target.getBoundingClientRect().top;
    const scrollY = window.pageYOffset;
    const buffer = 88; // headerHeight

    const top = elemY + scrollY - buffer;
    window.scroll({
      top: top,
      behavior: 'smooth',
    });
  });
}
smoothScroll();
